import { FormikProps } from "formik";
import { FC, useState } from "react";
import { WorkCreationSecondStep } from "../../../domain/models/dto/WorkDTO";
import { workCreationSecondStepFields } from "../../../validation-schemas/work-schemas/WorkCreationSchema";
import { useTranslation } from "react-i18next";
import CustomError from "../../../custom-components/form-inputs/CustomError";

interface ExpiresInComponentProps {
    form: FormikProps<WorkCreationSecondStep>;
    disabled?: boolean;
}

const ExpiresInComponent: FC<ExpiresInComponentProps> = (props) => {
    const { t } = useTranslation();

    const [hours, setHours] = useState(0);
    const [minutes, setMinutes] = useState(0);

    const handleHoursChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const newHours = Math.max(0, Math.min(23, parseInt(e.target.value, 10) || 0));
        setHours(newHours);
        props.form.setFieldValue("expiresInMinutes", newHours * 60 + minutes);
    };

    const handleMinutesChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const newMinutes = Math.max(0, Math.min(59, parseInt(e.target.value, 10) || 0));
        setMinutes(newMinutes);
        props.form.setFieldValue("expiresInMinutes", hours * 60 + newMinutes);
    };

    return (
        <div className="flex flex-col justify-center dmax5:items-start mt-4 dmax2:mt-3 dmax2:mb-6">
            <div
                className={`flex items-center dmin2:pl-[110px] ${
                    props.disabled && "opacity-40"
                } transition duration-300`}
            >
                <input
                    type={workCreationSecondStepFields.expiresInMinutes.type}
                    value={hours}
                    min={0}
                    max={23}
                    name="expiresInHours"
                    placeholder={workCreationSecondStepFields.expiresInMinutes.placeholderKey}
                    onChange={handleHoursChange}
                    disabled={props.form.values.showContactsAfterSelect}
                    className="input input-spinner-hidden h-[50px] dmax2:h-[48px] text-center"
                />
                <span className="H20 dmax2:H14B text-textFaded ml-3 dmax2:ml-2 mr-9 dmax2:mr-6">
                    {t("workCreation.fields.expiresInHours")}
                </span>
                <input
                    type={workCreationSecondStepFields.expiresInMinutes.type}
                    value={minutes}
                    min={0}
                    max={59}
                    name="expiresInMinutes"
                    placeholder={workCreationSecondStepFields.expiresInMinutes.placeholderKey}
                    onChange={handleMinutesChange}
                    disabled={props.form.values.showContactsAfterSelect}
                    className="input input-spinner-hidden h-[50px] dmax2:h-[48px] text-center"
                />
                <span className="H20 dmax2:H14B text-textFaded ml-3 dmax2:ml-2">
                    {t("workCreation.fields.expiresInMinutes")}
                </span>
            </div>
            <CustomError errorKey={props.form.errors.expiresInMinutes} className="mt-2 dmax2:mt-1" />
        </div>
    );
};

export default ExpiresInComponent;
